import React, { FC } from 'react'
import { addDays, startOfDay } from 'date-fns'
import { FormDate, FormInput, FormSelect } from 'components/FormWithGroup'
import { FormWhen } from 'components/Form'

import { AssignedProjects } from 'modules/Users/components'
import { useConfirmation } from 'components/Project/Confirmation'

import { IUserForm } from 'modules/Users/types'
import { SpacesField } from './Spaces'
import { ZonesField } from './Zones'
import { EmailField } from './Email'
import { Recap } from './Recap'

import { UserFormProps } from './UserForm.props'
import './UserForm.scss'

const isSpace = (role?: string): boolean => (role || '').includes('space')

const UserForm: FC<UserFormProps> = ({
  onSubmit,
  handleSubmit,
  control,
  userRolesOptions,
  isCreate,
  isExternalEmail
}) => {

  const [handleConfirm, modal] = useConfirmation<IUserForm>(onSubmit, {
    header: 'Assign Project?',
    actionText: 'Assign',
    condition: ({ assigned_campaigns }) => Boolean(isCreate && assigned_campaigns?.length),
    createMessage: (_, data) =>
      typeof data !== 'undefined' && Array.isArray(data?.assigned_campaigns) ? (
        <Recap list={data.assigned_campaigns} />
      ) : null
  })

  return (
    <form id="user-form" onSubmit={handleSubmit((data) => handleConfirm({ data, message: ''}))} className="user-form">
      <h3 className="user-form__title">Personal Info</h3>
      <EmailField isExternalEmail={isExternalEmail} isCreate={isCreate} />
      <FormInput
        label="First Name"
        placeholder="First"
        fieldName="first_name"
        control={control}
        rules={{ required: true }}
      />
      <FormInput
        label="Last Name"
        placeholder="Last"
        fieldName="last_name"
        control={control}
        rules={{ required: true }}
      />
      <h3 className="user-form__title">Role, Space, Zone</h3>
      <FormSelect
        label="Role"
        placeholder="Select Role"
        fieldName="role"
        options={userRolesOptions}
        control={control}
        rules={{ required: true }}
      />
      <FormWhen control={control} fieldName="role" is={role => !isSpace(role)}>
        <ZonesField />
      </FormWhen>
      <FormWhen control={control} fieldName="role" is={isSpace}>
        <SpacesField />
      </FormWhen>
      <FormWhen control={control} fieldName="email" is={() => isExternalEmail}>
        <FormDate
          label="Expiration Date"
          placeholder="Select Date"
          fieldName="expire_at"
          control={control}
          minDate={startOfDay(addDays(new Date(), 1))}
        />
      </FormWhen>
      <FormWhen
        control={control}
        fieldName="email"
        is={(email) => email.length > 0 && isExternalEmail}
      >
        <>
          <h3 className="user-form__title">Assign Project</h3>
          <AssignedProjects />
        </>
      </FormWhen>
      {
        modal
      }
    </form>
  )
}

export default UserForm
